import { useEffect, useState } from "react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "../ui/alert-dialog";
import { Textarea } from "../ui/textarea";

// action: { title, description, confirmLabel, needsReason, reasonOptional, run(reason) } | null
export function ConfirmDialog({ action, onClose, extra }) {
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => setReason(""), [action]);
  if (!action) return null;
  const wantsReason = action.needsReason || action.reasonOptional;
  const confirm = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await action.run(reason.trim());
      onClose();
    } finally {
      setBusy(false);
    }
  };
  return (
    <AlertDialog open onOpenChange={(o) => !o && onClose()}>
      <AlertDialogContent data-testid="confirm-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-display text-2xl text-[#4A000E]">{action.title}</AlertDialogTitle>
          <AlertDialogDescription>{action.description}</AlertDialogDescription>
        </AlertDialogHeader>
        {wantsReason && (
          <Textarea
            data-testid="confirm-reason-input"
            placeholder={action.needsReason ? "Reason (required)" : "Reason / note (optional)"}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            rows={3}
          />
        )}
        {extra}
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="confirm-cancel-button">Cancel</AlertDialogCancel>
          <AlertDialogAction
            data-testid="confirm-ok-button"
            disabled={busy || (action.needsReason && !reason.trim())}
            onClick={confirm}
            className="bg-[#7A0016] text-[#F5E6BA] hover:bg-[#4A000E]"
          >
            {action.confirmLabel || "Confirm"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
